import { useState } from 'react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Check, Copy } from 'lucide-react';

interface ConversationSheetProps {
  isOpen: boolean;
  onClose: () => void;
  protocol: string;
  conversationText?: string | null;
  isLoading?: boolean;
  isError?: boolean;
}

export function ConversationSheet({
  isOpen,
  onClose,
  protocol,
  conversationText,
  isLoading = false,
  isError = false,
}: ConversationSheetProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!conversationText) return;
    await navigator.clipboard.writeText(conversationText);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent className="w-full sm:max-w-2xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Conversa Extraída</SheetTitle>
          <SheetDescription>Protocolo {protocol}</SheetDescription>
        </SheetHeader>

        <div className="mt-6 space-y-3">
          {isLoading ? (
            <Card>
              <CardContent className="p-6 text-sm text-muted-foreground">
                Carregando conversa...
              </CardContent>
            </Card>
          ) : isError ? (
            <Card>
              <CardContent className="p-6 text-sm text-destructive">
                Falha ao carregar conversa skippada.
              </CardContent>
            </Card>
          ) : conversationText ? (
            <>
              <div className="flex justify-end">
                <Button variant="outline" size="sm" onClick={handleCopy}>
                  {copied ? (
                    <>
                      <Check className="h-4 w-4 mr-1" />
                      Copiado
                    </>
                  ) : (
                    <>
                      <Copy className="h-4 w-4 mr-1" />
                      Copiar
                    </>
                  )}
                </Button>
              </div>
              <Card>
                <CardContent className="p-4">
                  <pre className="text-sm whitespace-pre-wrap font-sans">{conversationText}</pre>
                </CardContent>
              </Card>
            </>
          ) : (
            <Card>
              <CardContent className="p-6 text-sm text-muted-foreground">
                Conversa não disponível - extraído antes da v2.
              </CardContent>
            </Card>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
